import { Plugin } from 'ckeditor5/src/core';
import { createDropdown, SplitButtonView, Model, addListToDropdown } from 'ckeditor5/src/ui';
import { Collection } from 'ckeditor5/src/utils';

import fileIcon from '../theme/icons/file.svg';
import FileListCommand from './filelistcommand';

export default class FileList extends Plugin {
  static get pluginName() {
    return 'FileList';
  }

  init() {
    const editor = this.editor;
    const t = editor.t;
    const model = editor.model;

    editor.commands.add( 'filelist', new FileListCommand( editor ) );

    editor.ui.componentFactory.add( 'filelist', locale => {
      const command = editor.commands.get( 'filelist' );
      const dropdownView = createDropdown( locale, SplitButtonView );
      const splitButtonView = dropdownView.buttonView;

      splitButtonView.set( {
        label: t( 'File list' ),
        icon: fileIcon,
        tooltip: true,
        isToggleable: true
      } );

      splitButtonView.actionView = editor.ui.componentFactory.create( 'uploadImage' );

      dropdownView.on( 'execute', evt => {
        editor.execute( 'filelist', {
          element: evt.source
        } );

        editor.editing.view.focus();
      } );

      dropdownView.class = 'ck-file-list-dropdown';
      dropdownView.bind( 'isEnabled' ).to( command );

      addListToDropdown( dropdownView, this._getFileListDefinitions() );

      return dropdownView;
    } );
  }

  _getFileListDefinitions() {
    const editor = this.editor;
    const itemDefinitions = new Collection();
    const files = editor.config.get( 'filelist.files' );

    for ( const file of files ) {
      const definition = {
        type: 'button',
        model: new Model( {
          _url: file.url,
          _type: file.type,
          label: file.name,
          withText: true
        } )
      };
      itemDefinitions.add( definition );
    }

    return itemDefinitions;
  }
}
